import {commitMutation, graphql, Environment, ConnectionHandler} from 'react-relay';
import {RecordSourceSelectorProxy, PayloadError} from 'relay-runtime';
import {
	DeleteSavedPromptMutation_Mutation,
	DeleteSavedPromptMutation_Mutation$data,
} from './__generated__/DeleteSavedPromptMutation_Mutation.graphql';
import Util from '../../forecast-app/shared/util/util';

const mutation = graphql`
	mutation DeleteSavedPromptMutation_Mutation($input: DeleteSavedPromptInput!) {
		deleteSavedPrompt(input: $input) {
			deletedSavedPromptId
		}
	}
`;

function storeUpdater(store: RecordSourceSelectorProxy): void {
	const payload = store.getRootField('deleteSavedPrompt');
	if (!payload) return;
	const deletedId = payload.getValue('deletedSavedPromptId') as string | null;
	if (!deletedId) return;

	const viewer = store.getRoot().getLinkedRecord('viewer');
	if (!viewer) return;

	const connection = ConnectionHandler.getConnection(viewer, 'PromptDropdown_savedPrompts');
	if (!connection) return;

	ConnectionHandler.deleteNode(connection, deletedId);
}

type MutationInput = {id: string};

function commit(
	environment: Environment,
	input: MutationInput,
	onSuccess?: (
		response: DeleteSavedPromptMutation_Mutation$data,
		errors: ReadonlyArray<PayloadError> | null | undefined
	) => void,
	onError?: (error: Error) => void
): void {
	const variables: DeleteSavedPromptMutation_Mutation['variables'] = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	commitMutation<DeleteSavedPromptMutation_Mutation>(environment, {
		mutation,
		variables,
		updater: storeUpdater,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
